import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const PublicRoadsIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Public roads - paved road with markings */}
    <path d="M4 4l4 16" />
    <path d="M20 4l-4 16" />
    <path d="M12 5v3" />
    <path d="M12 11v3" />
    <path d="M12 17v3" />
    <path d="M4 4h16" />
    <path d="M8 20h8" />
  </svg>
);
